import { TabGroup } from '@headlessui/react';
import { PlTab, PlTabList } from '@payaca/ambrosia';
import { clstx } from '@payaca/utilities/cvaMerge';
import { FC, Fragment, ReactNode, useState } from 'react';

type TabConfig = {
  label: string;
  badge?: ReactNode;
};

export type SidebarSplitProps = {
  leftTab: TabConfig;
  rightTab: TabConfig;
  /**
   * Two children, rendered into the left and right panels respectively.
   * Both panels stay mounted at all sizes — on mobile the inactive panel is
   * hidden via CSS so any form/input state inside is preserved when the user
   * switches tabs.
   */
  children: [ReactNode, ReactNode];
};

const SidebarSplit: FC<SidebarSplitProps> = (props) => {
  const { leftTab, rightTab, children } = props;
  const [selectedIndex, setSelectedIndex] = useState<0 | 1>(0);
  const [leftChild, rightChild] = children;

  return (
    <div className="grid h-full grow min-h-0 grid-rows-[auto_minmax(0,1fr)] md:grid-rows-[minmax(0,1fr)]">
      <TabGroup
        as={Fragment}
        selectedIndex={selectedIndex}
        onChange={(i) => setSelectedIndex(i as 0 | 1)}
      >
        <PlTabList
          variant="default"
          className="flex border-b bg-white md:hidden"
        >
          <PlTab fullWidth variant="default">
            <span>{leftTab.label}</span>
            {leftTab.badge}
          </PlTab>
          <PlTab fullWidth variant="default">
            <span>{rightTab.label}</span>
            {rightTab.badge}
          </PlTab>
        </PlTabList>
      </TabGroup>

      <div className="grid min-h-0 grid-cols-1 md:grid-cols-2">
        <div
          className={clstx(
            'grid min-h-0 grid-rows-[minmax(0,1fr)] overflow-hidden',
            selectedIndex !== 0 && 'hidden md:grid'
          )}
        >
          {leftChild}
        </div>
        <div
          className={clstx(
            'grid min-h-0 grid-rows-[minmax(0,1fr)] overflow-hidden',
            selectedIndex !== 1 && 'hidden md:grid'
          )}
        >
          {rightChild}
        </div>
      </div>
    </div>
  );
};

export default SidebarSplit;
